import { useCallback } from 'react';
import usePolling from './usePolling';
import { fetchCalls, fetchCallbacks, fetchAnalytics } from '../api/client';

export default function useDashboardData(filters = {}) {
  const callsFetcher = useCallback(() => fetchCalls(filters), [filters]);

  const calls = usePolling(callsFetcher);
  const callbacks = usePolling(fetchCallbacks);
  const analytics = usePolling(fetchAnalytics);

  const refreshAll = useCallback(() => {
    calls.refresh();
    callbacks.refresh();
    analytics.refresh();
  }, [calls, callbacks, analytics]);

  return { calls, callbacks, analytics, refreshAll };
}
